import {Component, Input, OnInit} from '@angular/core';
import {Pharmacy} from "../../../shared/model/pharmacy.model";
import {IonModal, NavController} from "@ionic/angular";
import {IconAction} from "../../../shared/model/icon-action.model";
import {CommonService} from "../../../shared/service/common.service";
import {LocationService} from "../../../shared/service/location.service";
import {actionType} from "../../../shared/types/types";
import {FirebaseEventEnum} from "../../../shared/enum/firebase-event.enum";
import {FirebaseService} from "../../../shared/service/firebase.service";

@Component({
  selector: 'app-pharmacy-card',
  templateUrl: './pharmacy-card.component.html',
  styleUrls: ['./pharmacy-card.component.scss'],
})
export class PharmacyCardComponent  implements OnInit {

  @Input() pharmacy: Pharmacy;
  @Input() showDistance: boolean;
  @Input() vediTutte: boolean;
  @Input() fullWidth: boolean;
  @Input() showSkeleton: boolean;
  @Input() mode: 'row' | 'card' = 'row';

  phoneAction: IconAction;
  actionWalk: IconAction;

  constructor(private commonService: CommonService,
              private navController: NavController,
              private firebaseService: FirebaseService,
              private locationService: LocationService) { }

  ngOnInit() {

    this.phoneAction = {
      icon: 'call',
      label: 'Chiama'
    };

    this.phoneAction.callback = () => {
      this.commonService.initiateCall(this.pharmacy.phoneNumber);
    };

    if (this.pharmacy?.address) {
      this.actionWalk = {
        icon: 'directions_walk',
        label: 'Vai',
        callback: () => {

          this.locationService.readUserLocation().subscribe((res) => {
            this.commonService.openGoogleMaps(this.pharmacy.coords.latitude, this.pharmacy.coords.longitude, res.lat, res.lng)
          });

        }
      }
    }

  }

  onSelectItem(actionsBtn){

    if(this.vediTutte){
      this.navController.navigateForward(['/pharmacies']);
      return;
    }

    this.firebaseService.logEvent(FirebaseEventEnum.CLICK_PHARM_CARD, {
      pharm_name: this.pharmacy.name
    });

    actionsBtn.open();
  }

  onSelectChange(event){
    const action: actionType = event.detail.value;
    if(action == 'phone'){

      this.firebaseService.logEvent(FirebaseEventEnum.CLICK_PHARM_PHONE, {
        pharm_name: this.pharmacy.name
      });

      this.commonService.initiateCall(this.pharmacy.phoneNumber);
    } else {

      this.firebaseService.logEvent(FirebaseEventEnum.CLICK_PHARM_ADDRESS, {
        pharm_name: this.pharmacy.name
      });

      this.commonService.openGoogleMaps(this.pharmacy.coords.longitude, this.pharmacy.coords.latitude)
    }
  }

}
